import React from 'react';

// JamInventra Logo using the uploaded image
export const JamInventraLogo = ({ height = 40, className = '' }) => {
  return (
    <img 
      src="/jaminventra-logo.jpg" 
      alt="JamInventra - Built in Jamaica, for Jamaicans"
      style={{ height: `${height}px`, width: 'auto' }}
      className={className}
    />
  );
};

export const JamInventraLogoFull = ({ height = 40, variant = 'default', className = '' }) => {
  return (
    <img 
      src="/jaminventra-logo.jpg" 
      alt="JamInventra - Built in Jamaica, for Jamaicans"
      style={{ height: `${height}px`, width: 'auto' }}
      className={className}
    />
  );
};

// For places that need just the icon (we'll use the full logo scaled down)
export const JamInventraIcon = ({ size = 32, className = '' }) => {
  return (
    <img 
      src="/jaminventra-logo.jpg" 
      alt="JamInventra"
      style={{ height: `${size}px`, width: 'auto' }}
      className={className}
    />
  );
};

export default JamInventraLogo;
